import { ProtectedRoute } from "@app/protected-route";
import {
	isPortfolioPartner,
	validatePortfolioSearch,
} from "@entities/portfolio/portfolio";
import { PortfolioLayout } from "@pages/portfolio/portfolio-layout/portfolio-layout";
import { createFileRoute } from "@tanstack/react-router";
import { partnerIdInstance } from "@utils/partner-id-instance";

export const Route = createFileRoute("/_layout/portfolio")({
	component: RouteComponent,
	validateSearch: validatePortfolioSearch,
});

function RouteComponent() {
	if (isPortfolioPartner(partnerIdInstance.getPartnerName())) {
		return <PortfolioLayout />;
	}

	return (
		<ProtectedRoute requiredPermissions={["root"]}>
			<PortfolioLayout />
		</ProtectedRoute>
	);
}
